<script setup lang="ts">
import { Link, usePage } from "@inertiajs/vue3"

import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import { type NavItem } from "@/types"

defineProps<{
  items: NavItem[]
}>()

const page = usePage()

function isActive(href: string) {
  if (href === "/") return page.url === href
  return page.url.startsWith(href)
}
</script>

<template>
  <SidebarGroup class="px-2 py-0">
    <SidebarMenu>
      <SidebarMenuItem v-for="item in items" :key="item.title">
        <SidebarMenuButton
          as-child
          :is-active="isActive(item.href)"
          :tooltip="item.title"
          size="xl"
        >
          <component
            :is="item.external ? 'a' : Link"
            :href="item.href"
            :target="item.external ? '_blank' : undefined"
            :rel="item.external ? 'noopener noreferrer' : undefined"
          >
            <component :is="item.icon" />
            <span class="font-sans">{{ item.title }}</span>
          </component>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  </SidebarGroup>
</template>
